/** Cobro al retirar: método, caja y estados de venta. Sin I/O. */
import { formatMoney } from '../../shared/format/public-api';

export const PICKUP_COLLECT_METHODS = ['cash', 'transfer', 'mercadopago_qr'] as const;
export type PickupCollectMethod = (typeof PICKUP_COLLECT_METHODS)[number];

export type CompleteOrderMode = 'collect' | 'qr_init' | 'qr_finalize';

export function isPickupCollectMethod(value: unknown): value is PickupCollectMethod {
  return value === 'cash' || value === 'transfer' || value === 'mercadopago_qr';
}

/** Default cash para callers viejos que no mandan medio. */
export function parsePickupCollectMethod(
  raw: unknown,
  alreadyPaid: boolean,
): PickupCollectMethod | null {
  if (alreadyPaid) return null;
  if (raw == null || raw === '') return 'cash';
  if (!isPickupCollectMethod(raw)) return null;
  return raw;
}

export function parseCompleteOrderMode(raw: unknown): CompleteOrderMode {
  if (raw === 'qr_init' || raw === 'qr_finalize') return raw;
  return 'collect';
}

export function salePaymentStatusForCollect(
  method: PickupCollectMethod | null,
  alreadyPaid: boolean,
  mode: CompleteOrderMode,
): 'paid' | 'pending' {
  if (alreadyPaid) return 'paid';
  if (mode === 'qr_init' || method === 'mercadopago_qr') return 'pending';
  return 'paid';
}

/** Caja abierta solo para efectivo y transferencia impagos. */
export function needsCashDrawerForCollect(
  method: PickupCollectMethod | null,
  alreadyPaid: boolean,
): boolean {
  if (alreadyPaid) return false;
  return method === 'cash' || method === 'transfer';
}

export function salePaymentMethodId(
  method: PickupCollectMethod | null,
  alreadyPaid: boolean,
  isMercadoPago: boolean,
): string {
  if (alreadyPaid && isMercadoPago) return 'mercadopago';
  if (method === 'transfer') return 'transfer';
  if (method === 'mercadopago_qr') return 'mercadopago_qr';
  return 'cash';
}

export function formatCollectAndDeliverCta(amount: number): string {
  return `Cobrar y entregar ${formatMoney(amount)}`;
}
